import Toast from '../components/pages/utils/Toast';
import { API } from '../constants/Constants';
import { UPLOAD_CATEGORY } from '../constants/staticContent';
import { DOCUMENT_TOAST } from '../constants/toastConstant';
import Instance from './interceptor';

export const pendingInprogress = async (type) => {
  try {
    const response = await Instance.get(
      `${API.PENDING_INPROGRESS_DOCUEMENTS}?documentType=${type}`,
    );
    return response?.data?.data;
  } catch (error) {
    if (error?.response) {
      Toast({ message: `${error?.response?.data?.message}`, variant: 'info' });
    } else if (error?.message) {
      Toast({
        message: `${error?.message}`,
        variant: 'error',
      });
    }
  }
};

export const getRowData = async (
  sorting,
  inputValue,
  filterModel,
  dropDownValue,
  documentType,
  page,
) => {
  const PAGE_LIMIT = 25;
  const stageValue =
    dropDownValue &&
    Object.keys(dropDownValue).length > 0 &&
    dropDownValue?.status &&
    dropDownValue.status.map((s) => s.status);
  const tagValue =
    dropDownValue &&
    Object.keys(dropDownValue).length > 0 &&
    dropDownValue?.associatedTags &&
    dropDownValue.associatedTags.map((t) => t.id);
  const data = {
    stage: stageValue || [],
    tags: tagValue || [],
    searchData: inputValue,
    filterModel,
    sortOrder: sorting && sorting?.[0]?.sort,
    sortField: sorting && sorting?.[0]?.colId,
    documentType,
    page,
    limit: PAGE_LIMIT,
  };
  try {
    const response = await Instance.post(`${API.GET_ROW_DATA}`, data);
    const hasSearchCriteria =
      stageValue?.length > 0 ||
      tagValue?.length > 0 ||
      inputValue ||
      (filterModel && Object.keys(filterModel)?.length > 0) ||
      sorting;
    if (
      hasSearchCriteria &&
      Object.keys(hasSearchCriteria)?.length > 0 &&
      response?.data?.data?.rows?.length === 0
    ) {
      Toast({
        message: DOCUMENT_TOAST.NO_RECORDS,
        variant: 'warning',
        position: { vertical: 'top', horizontal: 'center' },
        autoHideDuration: 4000,
      });
      return response?.data?.data?.rows;
    }
    return response?.data;
  } catch (error) {
    if (error?.response) {
      Toast({ message: `${error?.response?.data?.message}`, variant: 'info' });
    } else if (error?.message) {
      Toast({
        message: `${error?.message}`,
        variant: 'error',
      });
    }
  }
};
export const getOneDocument = async (id) => {
  try {
    return await Instance.get(`${API.GET_DOCUMENT}/${id}`);
  } catch (error) {
    if (error?.response?.data?.errorMessage) {
      Toast({
        message: `${error?.response?.data?.errorMessage}`,
        variant: 'error',
      });
    }
  }
};

export const sortRowData = async (
  sorting,
  inputValue,
  documentStage,
  tagId,
) => {
  const searchParam = inputValue;
  const data = {
    documentStage,
    tags: tagId,
    searchData: searchParam,
    sortOrder: sorting[0]?.sort,
    sortField: sorting[0]?.colId,
  };

  try {
    const response = await Instance.post(`${API.SORT_ROW_DATA}`, data);

    return response?.data?.documents;
  } catch (error) {
    if (error?.response?.data?.errorMessage) {
      Toast({
        message: `${error?.response?.data?.errorMessage}`,
        variant: 'error',
      });
    }
  }
};

export const deleteDocument = async ({ id }) => {
  try {
    const response = await Instance.delete(`${API.DELETE_DOCUMENT}/${id}`);
    if (response.status === 200) {
      Toast({ message: `${response.data.message}`, variant: 'success' });
    }
    return response;
  } catch (error) {
    if (error?.response) {
      Toast({
        message: `${error?.response?.data?.errorMessage}`,
        variant: 'error',
      });
    } else {
      Toast({ message: `${error.message}`, variant: 'error' });
    }
  }
};

export const exportXML = async (data) => {
  const versionId = data;
  try {
    const response = await Instance.get(
      `${API.EXPORT_XML}?versionId=${versionId}`,
    );
    if (response?.data) {
      return response.data;
    }
  } catch (error) {
    if (error?.response) {
      Toast({
        message: `${error?.response?.data?.errorMessage}`,
        variant: 'error',
      });
    }
    return error;
  }
};

export const exportXLSX = async (data) => {
  const versionId = data;
  try {
    console.log('hello');
    const response = await Instance.get(
      `${API.EXPORT_XLSX}?versionId=${versionId}`,
    );
    if (response?.data) {
      console.log('🚀 ~ exportXLSX ~ response.data:', response.data);
      return response.data;
    }
  } catch (error) {
    if (error?.response) {
      Toast({
        message: `${error?.response?.data?.errorMessage}`,
        variant: 'error',
      });
    }
    return error;
  }
};

export const exportJSON = async (data) => {
  const versionId = data;
  try {
    const response = await Instance.get(
      `${API.EXPORT_JSON}?versionId=${versionId}`,
    );
    if (response) {
      return response;
    }
  } catch (error) {
    if (error?.response) {
      Toast({
        message: `${error?.response?.data?.errorMessage}`,
        variant: 'error',
      });
    }
    return error;
  }
};

export const exportJSONFromGridAction = async (documentId) => {
  const requestedTag = {
    documents: documentId,
  };
  try {
    const response = await Instance.post(
      `${API.EXPORT_JSON_FROM_GRID_ACTION}`,
      requestedTag,
    );
    if (response) {
      return response;
    }
  } catch (error) {
    if (error?.response) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    }
    return error;
  }
};

export const exportXMLFromGridAction = async (documentId) => {
  const requestedTag = {
    documents: documentId,
  };
  try {
    console.log('hello');
    const response = await Instance.post(
      `${API.EXPORT_XML_FROM_GRID_ACTION}`,
      requestedTag,
    );
    if (response) {
      return response.data.data;
    }
  } catch (error) {
    if (error?.response) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    }
    return error;
  }
};

export const exportXLSXFromGridAction = async (documentId) => {
  const requestedTag = {
    documents: documentId,
  };
  try {
    const response = await Instance.post(
      `${API.EXPORT_XLSX_FROM_GRID_ACTION}`,
      requestedTag,
    );
    if (response) {
      return response.data.data;
    }
  } catch (error) {
    if (error?.response) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    }
    return error;
  }
};

export const addImportExportDetailsToDocumentSummary = async (
  documentId,
  fileName,
) => {
  const requestedTag = {
    documents: documentId,
    documentName: fileName,
  };
  try {
    const response = await Instance.post(
      `${API.ADD_IMPORT_EXPORT_DETAILS_TO_DOCUMENT_SUMMARY}`,
      requestedTag,
    );
    if (response) {
      return response.data.data;
    }
  } catch (error) {
    if (error?.response) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    }
    return error;
  }
};

export const renameDocument = async (id, documentName) => {
  const data = {
    name: documentName,
  };
  try {
    return await Instance.patch(`${API.RENAME_DOCUMENT}/${id}`, data);
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
  }
};

export const getColumnHideStatus = async (gridKey) => {
  const data = {
    grid_key: gridKey,
  };
  try {
    const response = await Instance.post(`${API.GET_INVOICE_COLUMN}`, data);
    return response?.data?.data?.settings;
  } catch (error) {
    if (error?.message) {
      Toast({ message: `${error.message}`, variant: 'error' });
    }
  }
};

export const updateColumnHideStatus = async (gridKey, settings) => {
  const data = {
    grid_key: gridKey,
    settings,
  };
  try {
    return await Instance.post(`${API.INVOICE_COLUMN}`, data);
  } catch (error) {
    Toast({ message: `${error.message}`, variant: 'error' });
  }
};

export const getGridFilterSortStatus = async (gridKey) => {
  const data = {
    grid_key: gridKey,
  };
  try {
    const response = await Instance.post(`${API.GET_INVOICE_COLUMN}`, data);
    return response?.data?.data;
  } catch (error) {
    if (error?.message) {
      Toast({ message: `${error.message}`, variant: 'error' });
    }
  }
};

export const gridFilterSortStatus = async (
  gridKey,
  sorting,
  filterModel,
  dropDownFilter,
) => {
  const data = {
    grid_key: gridKey,
    filter: { filterModel, dropDownFilter },
    sort: sorting,
  };
  try {
    return await Instance.post(`${API.INVOICE_COLUMN}`, data);
  } catch (error) {
    Toast({ message: `${error.message}`, variant: 'error' });
  }
};

export const deleteAllDocuments = async (
  inputValue,
  filterModel,
  dropDownValue,
  allRowSelected,
  functionData,
) => {
  const stageValue =
    dropDownValue &&
    Object.keys(dropDownValue).length > 0 &&
    dropDownValue.status.map((s) => s.status);
  const tagValue =
    dropDownValue &&
    Object.keys(dropDownValue).length > 0 &&
    dropDownValue.associatedTags.map((t) => t.id);
  const requestedTag = {
    stage: stageValue,
    searchData: inputValue,
    filterModel,
    tags: tagValue,
    allRowSelected,
    documentType: functionData,
  };
  try {
    return await Instance.post(`${API.DELETE_ALL_DOCUMENT}`, requestedTag);
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
    return error;
  }
};

export const deleteSelectedDocuments = async (documentId, allRowSelected) => {
  const requestedTag = {
    documents: documentId,
    allRowSelected,
  };
  try {
    return await Instance.post(`${API.DELETE_ALL_DOCUMENT}`, requestedTag);
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage ? error?.response?.data?.errorMessage : error.message}`,
      variant: 'error',
    });
    return error;
  }
};

export const getStage = async () => {
  try {
    const res = await Instance.get(`${API.GET_STAGE}`);
    return res?.data?.stages;
  } catch (error) {
    Toast({ message: `${error.message}`, variant: 'error' });
  }
};

export const exportAllDocumentToJSON = async (
  inputValue,
  filterModel,
  dropDownValue,
) => {
  const stageValue =
    dropDownValue &&
    Object.keys(dropDownValue).length > 0 &&
    dropDownValue.status.map((s) => s.status);
  const tagValue =
    dropDownValue &&
    Object.keys(dropDownValue).length > 0 &&
    dropDownValue.associatedTags.map((t) => t.id);
  const requestedTag = {
    stage: stageValue,
    searchData: inputValue,
    filterModel,
    tags: tagValue,
  };
  try {
    const res = await Instance.post(
      `${API.EXPORT_DOCUMENT_TO_JSON}`,
      requestedTag,
    );
    return res.data.data;
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
    return error;
  }
};

export const exportSelectedDocumentsToJSON = async (documentId) => {
  const requestedTag = {
    documents: documentId,
  };
  try {
    const res = await Instance.post(
      `${API.EXPORT_DOCUMENT_TO_JSON}`,
      requestedTag,
    );
    if (res) {
      return res.data.data;
    }
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
    // return error;
  }
};

export const exportAllDocumentToXML = async (
  inputValue,
  filterModel,
  documentStage,
  tagId,
) => {
  const requestedTag = {
    stage: documentStage,
    searchData: inputValue,
    filterModel,
    tags: tagId,
  };
  try {
    return await Instance.post(`${API.EXPORT_DOCUMENT_TO_XML}`, requestedTag);
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
    return error;
  }
};

export const exportSelectedDocumentsToXML = async (documentId) => {
  const requestedTag = {
    documents: documentId,
  };
  try {
    return await Instance.post(`${API.EXPORT_DOCUMENT_TO_XML}`, requestedTag);
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
    return error;
  }
};

export const sendAuthCodeOfQB = async (code, realmId, invoiceId) => {
  const data = {
    code,
    realmId,
    invoiceId,
    exportType: UPLOAD_CATEGORY.manual,
  };
  try {
    const authResponse = await Instance.post(
      `${API.SEND_AUTH_CODE_OF_QB}`,
      data,
    );
    if (authResponse?.data?.response) {
      return authResponse?.data?.response;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
};
